import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useLogout } from '@/data/auth'
import { PATHS } from '@/router/constants'
import { useStore } from '@/store'

export const LogoutTemplate = (): null => {
  const { mutate: logout } = useLogout()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const reason = searchParams.get('reason')

  useEffect(() => {
    // Clear the local storage of Zustand store
    useStore.persist.clearStorage()

    logout(
      { body: {} },
      {
        onSettled: () => {
          if (reason && reason !== 'email_not_verified') {
            const url = decodeURIComponent(reason)
            sessionStorage.setItem('redirectUrl', url)
            navigate(PATHS.LOGIN)
          } else if (reason === 'email_not_verified') {
            navigate(PATHS.EMAIL_VALIDATION)
          } else {
            navigate(PATHS.LOGIN)
          }
        },
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
